import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import SelectList from '../components/Common/SelectList/SelectList';

import {
    setNewBookingCostCentre,
} from '../actions/newBooking';

const descriptionFunc = (item) => item.description;

class CostCentreSelectorContainer extends Component {
    static propTypes = {
        person: PropTypes.object.isRequired,
        costCentres: PropTypes.object.isRequired,
        costCentreId: PropTypes.number,
        setNewBookingCostCentre: PropTypes.func.isRequired,
    };

    componentWillMount() {
        const { requirements, defaults } = this.props.person;

        // If a cost centre is required, and the user has a default cost centre, set it
        if (requirements && requirements.costCentre && defaults && defaults.costCentreId) {
            this.props.setNewBookingCostCentre(defaults.costCentreId);
        }
    }

    render() {
        return (
            <SelectList
                title="Select Cost Centre"
                items={this.props.costCentres}
                subValueFunc={descriptionFunc}
                selectedItemId={this.props.costCentreId}
                setSelectedItem={this.props.setNewBookingCostCentre}
            />
        );
    }
}

const mapStateToProps = (state) => {
    const { person } = state.environment;
    const { costCentres } = state.entities;
    const { costCentreId } = state.newBooking;

    return {
        person,
        costCentres,
        costCentreId,
    };
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setNewBookingCostCentre,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(CostCentreSelectorContainer);



// WEBPACK FOOTER //
// ./scripts/containers/CostCentreSelectorContainer.jsx